<template>
  <!-- nuevo diseño SalesRidge -->
  <div
    v-if="DesignFromSalesRidge === true"
    class="tabs-vertical tabs-salesridge"
  >
    <div
      v-for="(tab, key) in visibleTabs"
      :key="key"
      class="tabs-salesridge-item"
      :class="{ 'tabs-salesridge-item--active': tab.id === tabSelected }"
      @click="onTabClick(tab)"
    >
      <template v-if="tab.permission !== undefined">
        <a
          v-if="tab.permission === true"
          class="cursor-pointer"
          :class="(tab.disabled || disabled) ? 'disabledDiv' : ''"
        >
          <i v-if="tab.icon" :class="tab.icon"></i>
          {{ tab.label != null ? tab.label : tab.name }}{{ tab.total ? ' (' + tab.total + ')' : '' }}
        </a>
      </template>
      <template v-else>
        <a
          class="cursor-pointer"
          :class="(tab.disabled || disabled) ? 'disabledDiv' : ''"
        >
          <i v-if="tab.icon" :class="tab.icon"></i>
          {{ tab.label != null ? tab.label : tab.name }}{{ tab.total ? ' (' + tab.total + ')' : '' }}
        </a>
      </template>
    </div>
  </div>

  <!-- diseño agency (segunda imagen) -->
  <div
    v-else-if="DesignFromSalesRidge === false"
    class="tabs-vertical tabs-agency"
  >
    <div
      v-for="(tab, key) in visibleTabs"
      :key="key"
      class="tabs-agency-item"
      :class="{ 'tabs-agency-item--active': tab.id === tabSelected }"
      @click="onTabClick(tab)"
    >
      <template v-if="tab.permission !== undefined">
        <a
          v-if="tab.permission === true"
          class="cursor-pointer"
          :class="(tab.disabled || disabled) ? 'disabledDiv' : ''"
        >
          <i v-if="tab.icon" :class="tab.icon"></i>
          {{ tab.label != null ? tab.label : tab.name }}{{ tab.total ? ' (' + tab.total + ')' : '' }}
        </a>
      </template>
      <template v-else>
        <a
          class="cursor-pointer"
          :class="(tab.disabled || disabled) ? 'disabledDiv' : ''"
        >
          <i v-if="tab.icon" :class="tab.icon"></i>
          {{ tab.label != null ? tab.label : tab.name }}{{ tab.total ? ' (' + tab.total + ')' : '' }}
        </a>
      </template>
    </div>
  </div>

  <!-- Horizontal: diseño por defecto (comportamiento actual) -->
  <div v-else class="pb-1 border-bottom border-grey mt-2">
    <small
      v-for="(tab, key) in tabs"
      class="d-inline mr-3 it-tabs border-0 pb-1"
      :class="tab.id === tabSelected ? 'active' : ''"
      :key="key"
    >
      <template v-if="tab.permission">
        <a
          v-if="tab.permission == true"
          class="cursor-pointer d-inline"
          :class="(tab.disabled || disabled) ? 'disabledDiv' : ''"
          @click="changeTab(tab.id)">
          <i v-if="tab.icon" :class="tab.icon"></i>
          {{ tab.name }}
        </a>
      </template>
      <template v-else>
        <a class="cursor-pointer d-inline" :class="(tab.disabled || disabled) ? 'disabledDiv' : ''" @click="changeTab(tab.id)">
          <i v-if="tab.icon" :class="tab.icon"></i>
          {{ tab.name }} {{(tab.total) ? '('+ tab.total + ')' : ''}}
        </a>
      </template>
    </small>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    tabs: {
      default: false
    },
    tabSelected: Number,
    disabled: {
      default: false
    },
    DesignFromSalesRidge: {
      type: Boolean,
      default: undefined
    }
  },

  computed: {
    visibleTabs() {
      if (!this.tabs || !Array.isArray(this.tabs)) return [];
      return this.tabs.filter((t) => {
        const okPermission = t.permission === undefined || t.permission === true;
        const okHasPermission = t.hasPermission === undefined || t.hasPermission === true;
        return okPermission && okHasPermission;
      });
    }
  },

  methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab"
    }),
    onTabClick(tab) {
      if (tab.disabled || this.disabled) return;
      this.changeTab(tab.id);
    },
    changeTab(id) {
      this.$emit("change", id);
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    }
  }
};
</script>
<style scoped>
.disabledDiv {
  pointer-events: none;
  opacity: 0.4;
}

/* Vertical layout base */
.tabs-vertical {
  display: flex;
  flex-direction: column;
}

/* Diseño SalesRidge (primera imagen): fondo claro, separadores grises, activo azul */
.tabs-salesridge {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  overflow: hidden;
}

.tabs-salesridge-item {
  padding: 0.65rem 1rem;
  border-bottom: 1px solid #e8e8e8;
  transition: background 0.15s, color 0.15s;
}

.tabs-salesridge-item:last-child {
  border-bottom: none;
}

.tabs-salesridge-item a {
  color: #3f3d56;
  text-decoration: none;
  display: block;
}

.tabs-salesridge-item--active {
  background: #5054EB;
  color: #fff;
}

.tabs-salesridge-item--active a {
  color: #fff;
}

/* Diseño agency (segunda imagen): fondo oscuro, texto blanco, activo azul redondeado */
.tabs-agency {
  background: #2d2d2d;
  padding: 0.5rem 0;
  border-radius: 0 8px 8px 0;
}

.tabs-agency-item {
  padding: 0.5rem 1rem;
  margin: 2px 0;
  transition: background 0.15s;
}

.tabs-agency-item a {
  color: #fff;
  text-decoration: none;
  display: block;
}

.tabs-agency-item--active {
  background: #4a47eb;
  border-radius: 0 20px 20px 0;
}
</style>
